export default "__VITE_ASSET__38af5181__"